import React, { useMemo } from 'react'
import AddOnsTile from './AddOnsTile'
import { Button } from '@corratech/pylot-ui'
import { AdonsStepProps } from '../../lib/type'
import { useTranslation } from 'next-i18next'
import { BundleItemOption } from '@pylot-data/fwrdschema'
import { Subtotal } from '../Subtotal/Subtotal'
import s from './AddOnsStep.module.scss'
import cn from 'classnames'
import { useUI } from '@corratech/pylot-ui/context'

export const AddOnsStep = ({
    product,
    setStep,
    step,
    selectedOptions,
    setSelectedOptions,
    addOns,
    setAddOns,
    addProductHandler,
    isAddToCartInProgress,
    isFavourite
}: AdonsStepProps): JSX.Element => {
    const adons = product?.items?.filter(
        (item) => item?.ooka_product_option == 'pods'
    )
    const { t } = useTranslation(['common', 'plp'])
    const { cartEditId } = useUI()
    const selectedOptionsAdons: BundleItemOption[] = []
    adons?.forEach((flavour) => {
        flavour?.options?.forEach((option) => {
            if (selectedOptions?.includes(String(option?.uid))) {
                selectedOptionsAdons.push(option!)
            }
        })
    })

    const isCustomKit =
        product?.is_custom_kit && product?.url_key === 'custom-kit'

    const buttonLabel = useMemo(() => {
        if (isAddToCartInProgress) return ''
        return t('GO TO CHECKOUT')
    }, [isAddToCartInProgress, cartEditId])

    /** Combine adons for each unique product */
    return (
        <div>
            <div className={s['addon-container']}>
                <div className={s['addon-title-wrapper']}>
                    <p className={s['upgrade-your']}>
                        {isCustomKit
                            ? t('Upgrade your Experience')
                            : t('Add-ons')}
                    </p>
                    {!isCustomKit ? (
                        <p className={s['sub-pick-any']}>
                            {t(
                                `Add more devices or accessories to upgrade your experience.`
                            )}
                        </p>
                    ) : null}
                </div>
                <div className={cn(s['flavour-list'])}>
                    {product?.upsell_products?.map(
                        (indivudalProduct, index) => {
                            return (
                                <div
                                    key={indivudalProduct?.sku}
                                    className={
                                        product.upsell_products?.length === 1
                                            ? 'col-start-2'
                                            : ''
                                    }
                                >
                                    <AddOnsTile
                                        index={index}
                                        product={indivudalProduct}
                                        className="item"
                                        selectedOptions={selectedOptions}
                                        setSelectedOptions={setSelectedOptions}
                                        addOns={addOns}
                                        disableAddingAdons={
                                            indivudalProduct?.stock_status ===
                                            'OUT_OF_STOCK'
                                        }
                                        qty={
                                            addOns?.[indivudalProduct?.sku!]
                                                ?.qty
                                        }
                                        setAddOns={setAddOns}
                                    />
                                </div>
                            )
                        }
                    )}
                </div>
            </div>
            <div className={s['price-container']}>
                {!isFavourite ? (
                    <div className={s['price']}>
                        <Subtotal
                            product={product}
                            selectedOptions={selectedOptions}
                            addOns={addOns}
                        />
                    </div>
                ) : (
                    ''
                )}
                <div>
                    <Button
                        type="button"
                        className={s['add-to-cart-button']}
                        loading={isAddToCartInProgress}
                        onClick={() => {
                            // @TODO Maybe we have to do add to cart
                            if (
                                setStep &&
                                typeof step == 'number' &&
                                addProductHandler
                            ) {
                                addProductHandler(Object.keys(adons!))
                            }
                        }}
                    >
                        {buttonLabel}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default AddOnsStep
